angular.module('bmsApp.accounting')
	.controller('InvoiceSaveCtrl', [
		'$scope',
		'$state',
		'$q',
		'$timeout',
		'notify',
		'CustomerSvc',
		'AccountingSvc',
		'TaxHelperSvc',
		'MMInvoiceSvc',
		'MMJobPartSvc',
		'SMInvoiceSvc',
		'SMJobSvc',
		'TGInvoiceSvc',
		'TGJobSvc',
		function ($scope,
				  $state,
				  $q,
				  $timeout,
				  notify,
				  CustomerSvc,
				  AccountingSvc,
				  TaxHelperSvc,
				  MMInvoiceSvc,
				  MMJobPartSvc,
				  SMInvoiceSvc,
				  SMJobSvc,
				  TGInvoiceSvc,
				  TGJobSvc) {

			$scope.invoiceForm = {
				processing: false,
				loading: true,
				invoice: null,
				options: {},
				protos: {
					invoiceProto: function () {
						return {
							parts: [
								$scope.invoiceForm.protos.partProto()
							],
							total_net: 0,
							vat_rate_applied: 0,
							total_vat: 0,
							total_gross: 0
						};
					},
					partProto: function () {
						return {
							net_amount: 0,
							vat_applied: 0,
							vat_amount: 0,
							gross_amount: 0
						};
					}
				},
				methods: {
					init: function () {
						$scope.invoiceForm.invoice = $scope.invoiceForm.protos.invoiceProto();
						$q.all([
							$scope.invoiceForm.methods.populateFormOptions(),
							TaxHelperSvc.setVatRate()
						])
							.then(function () {
								$scope.invoiceForm.methods.selectPreferredVatRate();
								$scope.invoiceForm.methods.initWatches();
								$scope.invoiceForm.loading = false;
							});
					},
					initWatches: function () {
						$scope.$watch('invoiceForm.invoice.vat_rate_applied', function (newValue) {
							// set the vat rate on each part and recalculate vat, gross and invoice totals
							angular.forEach($scope.invoiceForm.invoice.parts, function (part) {
								part.vat_applied = newValue;
								$scope.invoiceForm.methods.calcPartAmountFromGross(part)
							});
							$scope.invoiceForm.methods.sumParts();
						});
					},
					selectPreferredVatRate: function () {
						angular.forEach($scope.invoiceForm.options.vatRate, function (vatRate) {
							if (vatRate.preferred) {
								$scope.invoiceForm.invoice.vat_rate_applied = vatRate.value;
							}
						});
					},
					populateFormOptions: function () {
						var promises = {
							customerOptions: CustomerSvc.options(),
							vatRateOptions: AccountingSvc.vatRateOptions()
						};
						return $q.all(promises)
							.then(function (responses) {
								$scope.invoiceForm.options.customer = responses.customerOptions.data.options;
								console.log(responses);
								$scope.invoiceForm.options.vatRate = responses.vatRateOptions.data.options;
							});
					},
					populateMmJobPartOptions: function (customerId) {
						if (angular.isNumber(customerId)) {
							var promises = {
								mmJobPartOptions: MMJobPartSvc.customerInvoiceOptions(customerId)
							};
							$q.all(promises)
								.then(function (responses) {
									$timeout(function () {
										$scope.$apply(function () {
											$scope.invoiceForm.options.mmJobPart = responses.mmJobPartOptions.data.options;
										});
									});
								});
						}
						else {
							$scope.invoiceForm.options.mmJobPart = [];
							delete $scope.invoiceForm.invoice.job_part;
						}
					},
					populateSmJobOptions: function (customerId) {
						if (angular.isNumber(customerId)) {
							var promises = {
								smJobOptions: SMJobSvc.customerInvoiceOptions(customerId)
							};
							$q.all(promises)
								.then(function (responses) {
									$timeout(function () {
										$scope.$apply(function () {
											$scope.invoiceForm.options.smJob = responses.smJobOptions.data.options;
										})
									});
								});
						}
						else {
							$scope.invoiceForm.options.smJob = [];
							delete $scope.invoiceForm.invoice.job;
						}
					},
					populateTgJobOptions: function (customerId) {
						if (angular.isNumber(customerId)) {
							var promises = {
								tgJobOptions: TGJobSvc.customerInvoiceOptions(customerId)
							};
							$q.all(promises)
								.then(function (responses) {
									$timeout(function () {
										$scope.$apply(function () {
											$scope.invoiceForm.options.tgJob = responses.tgJobOptions.data.options;
										});
									});
								});
						}
						else {
							$scope.invoiceForm.options.tgJob = [];
							delete $scope.invoiceForm.invoice.job;
						}
					},
					addPart: function () {
						// use part prototype with current selected vat rate
						// no need to recalc since default part values are 0
						var part = angular.extend({}, $scope.invoiceForm.protos.partProto(), {
							vat_applied: $scope.invoiceForm.invoice.vat_rate_applied
						});
						$scope.invoiceForm.invoice.parts.push(part);
					},
					removePart: function (part) {
						// requires at least one part
						if ($scope.invoiceForm.invoice.parts.length > 1) {
							var index = $scope.invoiceForm.invoice.parts.indexOf(part);
							$scope.invoiceForm.invoice.parts.splice(index, 1);
							$scope.invoiceForm.methods.sumParts();
						}
					},
					calcPartAmountFromNet: function (part) {
						part.vat_amount = TaxHelperSvc.vatFromNet(part.net_amount, part.vat_applied);
						part.gross_amount = TaxHelperSvc.grossFromNet(part.net_amount, part.vat_applied);
					},
					calcPartAmountFromGross: function (part) {
						part.net_amount = TaxHelperSvc.netFromGross(part.gross_amount, part.vat_applied);
						part.vat_amount = TaxHelperSvc.vatFromGross(part.gross_amount, part.vat_applied);
					},
					sumParts: function () {
						$scope.invoiceForm.invoice.total_net = 0;
						$scope.invoiceForm.invoice.total_vat = 0;
						$scope.invoiceForm.invoice.total_gross = 0;
						angular.forEach($scope.invoiceForm.invoice.parts, function (part) {
							$scope.invoiceForm.invoice.total_net += part.net_amount;
							$scope.invoiceForm.invoice.total_vat += part.vat_amount;
							$scope.invoiceForm.invoice.total_gross += part.gross_amount;
						});
					}
				},
				eventHandlers: {
					onCustomerChange: function () {
						var customerId = angular.isObject($scope.invoiceForm.invoice.customer) ? $scope.invoiceForm.invoice.customer.id : null;
						if ($scope.isMM()) {
							delete $scope.invoiceForm.invoice.job_part;
							$scope.invoiceForm.methods.populateMmJobPartOptions(customerId);
						}
						if ($scope.isSM()) {
							delete $scope.invoiceForm.invoice.job;
							$scope.invoiceForm.methods.populateSmJobOptions(customerId);
						}
						if ($scope.isTG()) {
							delete $scope.invoiceForm.invoice.job;
							$scope.invoiceForm.methods.populateTgJobOptions(customerId);
						}
					},
					onPartNetAmountChange: function (part) {
						$scope.invoiceForm.methods.calcPartAmountFromNet(part);
						$scope.invoiceForm.methods.sumParts();
					},
					onPartGrossAmountChange: function (part) {
						$scope.invoiceForm.methods.calcPartAmountFromGross(part);
						$scope.invoiceForm.methods.sumParts();
					},
					calculateTotals: function () {
						angular.forEach($scope.invoiceForm.invoice.parts, function (part){
							part.vat_applied = $scope.invoiceForm.invoice.vat_rate_applied;
							$scope.invoiceForm.methods.calcPartAmountFromNet(part);
						})
						$scope.invoiceForm.methods.sumParts();
					},
				},
				formvalidatorconfig: {
					submitHandler: function () {
						$scope.invoiceForm.processing = true;
						var promise;
						if ($scope.isMM()) {
							promise = MMInvoiceSvc.save($scope.invoiceForm.invoice);
						}
						if ($scope.isSM()) {
							promise = SMInvoiceSvc.save($scope.invoiceForm.invoice);
						}
						if ($scope.isTG()) {
							promise = TGInvoiceSvc.save($scope.invoiceForm.invoice);
						}
						if (angular.isDefined(promise)) {
							promise.then(function () {
								notify({
									message: 'Invoice created successfully'
								});
								$state.go('main.accounting.invoice.index');
							}, function (error) {
								$scope.invoiceForm.errors = error;
							})
								.finally(function () {
									$scope.invoiceForm.processing = false;
								});
						}
					},
					errorPlacement: function (error) {
						error.appendTo('#invoice-errors');
					},
					errorContainer: '#invoice-errors'
				}
			};

			$scope.invoiceForm.methods.init();

		}
	]);
